import React from 'react';
import clsx from 'clsx';
import { buildMediaQuery } from '@marriott/shared/mi-helper-utils';
import { ImageProps, RenditionProps } from './MerchImage.types';

// Extend img attributes to include fetchpriority (not yet in React types)
type ImgPropsWithFetchPriority = React.ImgHTMLAttributes<HTMLImageElement> & {
  fetchpriority?: 'high' | 'low' | 'auto';
  'data-src'?: string;
};

export const MerchImage = (props: ImageProps) => {
  const {
    title,
    defaultImageURL,
    customClass,
    renditions,
    altText = 'Card Overview Image',
    loading = 'lazy',
    priority = false,
    // Destructure to avoid forwarding an invalid prop to <img> when spreading rest props.
    dynamic: _dynamic,
    className,
    ...restImgProps
  } = props;

  const imgLoading = priority ? 'eager' : loading;

  const imgProps: ImgPropsWithFetchPriority = {
    ...restImgProps,
    src: defaultImageURL,
    className: clsx('image', imgLoading, className, customClass),
    alt: altText,
    title: title,
    'data-src': defaultImageURL,
    loading: imgLoading,
    decoding: priority ? 'sync' : 'async',
    ...(priority && { fetchpriority: 'high' }),
  };

  return (
    <picture data-component-name="m-merchandising-image" data-testid="merchandising-image">
      {renditions?.map((rendition: RenditionProps, index: number) => {
        const { renditionPath, mediaValue, mediaQuery } = rendition;
        const media = buildMediaQuery(mediaQuery, mediaValue);
        return renditionPath?.length ? (
          <source key={index} media={media} srcSet={renditionPath} data-testid={'source-img-' + index} />
        ) : null;
      })}

      {defaultImageURL && <img {...imgProps} alt={altText || ''} />}
    </picture>
  );
};
